/**
 * Notifications API client
 * Handles combined notifications summary (friend requests + unread chats)
 */

import { BASE_URL } from '../../../shared/lib/api';

export interface NotificationsSummary {
  pendingFriendRequests: number;
  unreadConversationCount: number;
  hasUnread: boolean;
  lastUpdated: string;
}

export async function getNotificationsSummary(
  token: string
): Promise<NotificationsSummary> {
  const response = await fetch(`${BASE_URL}/notifications/summary`, {
    method: 'GET',
    headers: {
      'Authorization': `Bearer ${token}`,
      'Content-Type': 'application/json',
    },
  });

  if (!response.ok) {
    const error = await response.json().catch(() => ({ error: 'Failed to fetch notifications summary' }));
    throw new Error(error.error || `HTTP ${response.status}: ${response.statusText}`);
  }

  return response.json();
}
